'use strict';

module.exports = {
    lazyLoadCarouselImages: function () {
        $('.pdp-carousel').on('slide.bs.carousel', function (e) {
            // A max height and max width is getting added via a style attribute by some third party JS library.
            // This is preventing the full image from being shown, when we browse through the PDP carousel main images in mobile view
            // Below code changes are for removing these style values when customer scrolls through the PDP main image carousel
            var image = $(e.relatedTarget).find('img[data-src]');
            if (image.length > 0) {
                var style = image.attr('style');
                if (style) {
                    style = style.replace(/max-width: [^;]*;?/, '');
                    style = style.replace(/max-height: [^;]*;?/, '');
                    style = style.trim();
                    image.attr('style', style);
                }
            }
        });
    }
};
